<template>
  <BlogPaginationPage
    :posts="posts"
    :categories="categoriesList ?? []"
    :loading="pending"
    :count-articles="count"
    :current-page="currentPage"
  >
    <template #title>
      <h1 class="landing_h1 mb-8 text-center">
        <Translate translate-key="page_data.blog.h1" />
      </h1>
    </template>
  </BlogPaginationPage>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import BlogPaginationPage from "~/slices/blog/components/BlogPaginationPage.vue";
import {
  useBlogCategories,
  useBlogList,
  BLOG_ITEMS_PER_PAGE,
} from "~/slices/blog/composables/queries";

definePageMeta({ layout: "public" });

const route = useRoute();

const currentPage = computed(() => {
  return 1;
});
const search = computed(() => (route.query.search as string) || "");
const categories = computed(() => (route.query.categories as string) || "");

const { data: categoriesList } = useBlogCategories();
const {
  data: posts,
  count,
  pending,
  refresh: refreshBlogList,
} = useBlogList(currentPage, search, categories);
const { t } = useI18n();

watch(
  () => route.path,
  () => refreshBlogList(),
  { immediate: false },
);

const config = useRuntimeConfig();
const localePath = useLocalePath();

useSeoMeta({
  title: () => t("page_data.blog.seo_title"),
  description: () => t("page_data.blog.seo_description"),
  ogTitle: () => t("page_data.blog.seo_title"),
  ogDescription: () => t("page_data.blog.seo_description"),
  ogImageAlt: "Increase your credit score fast with GFSGroup",
});
useHead(() => {
  const siteUrl = (config.public.siteUrl as string) || "";
  const canonical = siteUrl ? `${siteUrl}${localePath("/blog")}` : undefined;
  return {
    link: canonical ? [{ rel: "canonical", href: canonical }] : [],
    meta: [{ name: "keywords", content: t("page_data.blog.seo_keywords") }],
  };
});
</script>
